import {createStore, combineReducers, applyMiddleware} from 'redux';
import actionReducer from "./reducers/actionReducer";
import commonReducer from "./reducers/commonReducer";
import userReducer from "./reducers/userReducer";
import postingReducer from "./reducers/postingReducer";

const localStorageMiddleware = ({getState}) => {
    return (next) => (action) => {
        const result = next(action);
        if(typeof localStorage !== 'undefined') {
            localStorage.setItem('state', JSON.stringify(
                {
                    common: getState().common,
                }
            ));
        }
        return result;
    };
};

const reHydrateStore = () => {
    if (typeof localStorage !== 'undefined' && localStorage.getItem('state') !== null) {
        return JSON.parse(localStorage.getItem('state'));

    }
};

const rootReducer = combineReducers({
    common: commonReducer,
    user: userReducer,
    posting: postingReducer,
    action: actionReducer,
});

const store = createStore(rootReducer, reHydrateStore(), applyMiddleware(localStorageMiddleware));


export default store;
